import { useQuery } from '@tanstack/react-query';
import * as ref from '@core/services/referenceService';

const REF_KEY = 'reference';
const FIVE_MIN = 5 * 60 * 1000;

export function usePaymentMethods() {
  return useQuery({
    queryKey: [REF_KEY, 'paymentMethods'],
    queryFn: ref.listPaymentMethods,
    staleTime: FIVE_MIN,
  });
}

export function useCountries(options = {}) {
  return useQuery({
    queryKey: [REF_KEY, 'countries'],
    queryFn: ref.listCountries,
    staleTime: FIVE_MIN,
    ...options,
  });
}

export function useCurrencies() {
  return useQuery({
    queryKey: [REF_KEY, 'currencies'],
    queryFn: ref.listCurrencies,
    staleTime: FIVE_MIN,
  });
}
